export default ({format,locale,date})=>{
  if(!date){
    return ""
  }
  if(!locale){
    locale = (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.language;
  }
  let formatter = {}
  if(format.match(/d/)){
    formatter.day = format.match(/dd/) ? "2-digit" : "numeric"
  }
  if(format.match(/M/)){
    formatter.month = format.match(/MMMM/) ? "long" : format.match(/MMM/) ? "short" : format.match(/MM/) ? "2-digit" : "numeric"
  }
  if(format.match(/yy/)){
    formatter.year = format.match(/yyyy/) ? "numeric" : "2-digit"
  }
  if(format.match(/h/)){
    formatter.hour = format.match(/hh/) ? "2-digit" : "numeric"
    formatter.hour12 = true
  }
  if(format.match(/H/)){
    formatter.hour = format.match(/HH/) ? "2-digit" : "numeric"
    formatter.hour12 = false
  }
  if(format.match(/m/)){
    formatter.minute = format.match(/mm/) ? "2-digit" : "numeric"
  }
  if(format.match(/s/)){
    formatter.second = format.match(/ss/) ? "2-digit" : "numeric"
  }
  if(format.match(/E/)){
    formatter.weekday = format.match(/EEEE/) ? "long" : format.match(/EEE/) ? "short" : "narrow"
  }
  let dateString =  new Intl.DateTimeFormat(locale,formatter).format(new Date(date))
  return dateString
}

export const parse = (({format,value,utc=false})=>{
  if(typeof value != "string") return value
  try {
    const matchers = {
      'yyyy':{reg:'([0-9]{4})',param:0},
      'yy':{reg:'([0-9]{2})',param:0},
      'M':{reg:'([0-9]{1,2})',param:1},
      'MM':{reg:'([0-9]{1,2})',param:1},
      'MMM':{reg:'([a-z]{3})',param:1},
      'MMMM':{reg:'([a-z]+)',param:1},
      'dd':{reg:'([0-9]{1,2})',param:2},
      'dd':{reg:'([0-9]{1,2})',param:2},
      'd':{reg:'([0-9]{1,2})',param:2},
    }
    let counter = 0
    let datePart = []
    let pattern = format.replace(/([a-z])+/ig,(val)=>{
      if(matchers[val]){
        datePart[counter] = val
        counter++
        return matchers[val].reg 
      }
      return val
    })
    let regex = new RegExp(pattern,"i")
    let vals = value.match(regex)
    let params = []
    datePart.forEach((val,idx)=> params[matchers[val].param] = vals[idx+1])
    if(params[1]-1>-1){
      if(params[1]) params[1] = params[1]-1   // substract 1 from month
    }else{
      //lookup txt month
      params[1] = DateFormat.i18n.months.indexOf((DateFormat.i18n.months.filter( month => params[1].substr(0,3) == month.substr(0,3))[0]))
    }
    
    //treat all years under 90 as 2090
    if(params[0] < 90) params[0] = "20"+params[0] 
    if(utc) return new Date(Date.UTC(params[0],params[1],params[2]))
    return new Date(params[0],params[1],params[2])
  }catch(e){
    throw new Error("invalid date "+value)
  }
})